if (!customElements.get("localized-atc")) {
  class LocalizedATC extends HTMLElement {
    constructor() {
      super();
      this.outOfStockText = this.dataset.oosText
      this.inStockText = this.dataset.isText
      this.isAvailable = this.dataset.available === 'true'
      this.outOfStockVariants = this.dataset.oosVariants?.split('|').filter(Boolean).map((val) => parseInt(val)) || []
      this.defaultVar = parseInt(this.dataset.defaultVar)

      this.button = this.querySelector('#AddToCart')
      this.alternativePaymentButton = this.querySelector('.alternative-payment-button')
  
    }

    connectedCallback() {
      if (this.button) {
        window.addEventListener('locationchange', () => {
            const params = new URLSearchParams(window.location.search)
            if (params.get('variant')) {
              this.handleLocalizedOOS({detail: {variant: {id: parseInt(params.get('variant'))}}})
            }
        });
        this.handleLocalizedOOS({detail: {variant: {id: this.defaultVar}}})
      }
      
    }
    handleLocalizedOOS({detail}) {
      if (this.isAvailable) {
        const newVariant = detail.variant
        if (newVariant) {
          if (this.outOfStockVariants.includes(newVariant.id)) {
            const button = document.querySelector('#AddToCart')
            button.disabled = true
            // button.setAttribute('disabled',"disabled") 
            // button.classList.add('td-latc--disabled')
            const buttonTextWrapper = button.querySelector('.long-text.js')
            if (buttonTextWrapper) {
              buttonTextWrapper.innerText = this.outOfStockText
            }
            const stickyButton = document.querySelector('.btn.td-btn--alt')
            stickyButton.disabled = true
            const stickyButtonTextWrapper = stickyButton.querySelector('.long-text.js')
            if (stickyButtonTextWrapper) {
              stickyButtonTextWrapper.innerText = this.outOfStockText
            }
            
            if(this.alternativePaymentButton) this.alternativePaymentButton.style.display = 'none'; 
          } else {
            const button = document.querySelector('#AddToCart')
            button.disabled = false
            const buttonTextWrapper = button.querySelector('.long-text.js')
            if (buttonTextWrapper) {
              buttonTextWrapper.innerText = this.inStockText
            }
            const stickyButton = document.querySelector('.btn.td-btn--alt')
            stickyButton.disabled = false
            const stickyButtonTextWrapper = stickyButton.querySelector('.long-text.js')
            if (stickyButtonTextWrapper) {
              stickyButtonTextWrapper.innerText = this.inStockText
            }
            
            if(this.alternativePaymentButton) this.alternativePaymentButton.style.display = 'flex'; 
          }
          
        }
      }
    }

  }

  customElements.define("localized-atc", LocalizedATC);
}
